<template>
  <div class="order-complete">
    <div class="columns is-multiline">
      <div class="column is-12-mobile is-12-tablet is-6 is-6-desktop cp-top-column-order-complete">
        <nav class="panel" v-if="cpOrderQuoteResponse">
          <p class="panel-heading">
            Your order
          </p>
          <div class="panel-block">
            <table class="table is-fullwidth">
              <tbody>
                <tr>
                    <td colspan="2" style="    padding: 0;">

                        <table class="table is-fullwidth" style="margin-left: 0;">
                            <tbody>

                                <tr>
                                    <th>Product</th>
                                    <th>Quantity</th>
                                </tr>

                                <tr v-for="itemReference of reorderData.reorderItemsReferences" v-bind:key="itemReference">
                                    <td>{{reorderData.productsInfo[itemReference].name}}</td>
                                    <td>{{reorderData.productsQuantity[itemReference]}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr v-if="!quoteError && cpOrderQuoteResponse.subtotals">
                  <td style="padding-top: 13px;">
                      <p style="font-weight: bold">Delivery address</p>
                      <p v-show="reorderData.shippingAddress.company">
                        {{reorderData.shippingAddress.company}}
                      </p>
                      <p>{{reorderData.shippingAddress.firstname}} {{reorderData.shippingAddress.lastname}}</p>
                      <p>{{reorderData.shippingAddress.street1}}</p>
                      <p v-if="reorderData.shippingAddress.street2">{{reorderData.shippingAddress.street2}}</p>
                      <p>{{reorderData.shippingAddress.zip}},  {{reorderData.shippingAddress.city}}</p>
                      <p>{{$store.getters['cpReorder/countryName']}}</p>
                      <p v-if="reorderData.stateIsRequired">, {{$store.getters['cpReorder/stateName']}}<p/>
                      <p>{{reorderData.shippingAddress.email}}</p>
                      <p>{{reorderData.shippingAddress.phone}}</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </nav>
      </div>

      <div class="column is-12-mobile is-12-tablet is-6 is-6-desktop cp-top-column-order-complete">
        <nav class="panel" v-if="cpOrderQuoteResponse">
          <p class="panel-heading">
            Order summary
          </p>
          <div class="panel-block">
            <table class="table is-fullwidth">
              <tbody>
                <tr v-if="!quoteError && cpOrderQuoteResponse.subtotals">
                  <td style="font-weight: bold">Products price</td>
                  <td class="has-text-right">
                    {{'0.00' | currency}}
                  </td>
                </tr>
                <tr v-if="!quoteError && cpOrderQuoteResponse.subtotals">
                  <td style="font-weight: bold">Fee</td>
                  <td class="has-text-right">
                    {{'0.00' | currency}}
                  </td>
                </tr>
                <tr v-for="(cpOrderShipping, index) of reorderData.cpOrderShipping" v-bind:key="index">
                  <td style="font-weight: bold; width: 40%">Shipping method <br>
                      <ul>
                        <li style="font-weight: normal; font-size: 13px;" v-for="productName of cpOrderShipping.products" v-bind:key="productName">– {{productName}} <br></li>
                      </ul>
                  </td>
                  <td class="has-text-right">
                    <span v-if="quoteError" style="color: #ff3860;">
                        {{quoteError}}
                    </span>
                    <section class="has-text-left" id="shipping-methods">
                      <small class="help is-danger" v-if="cpOrderShipping.quotes.length == 0">The shipping is not possible. Please, contact support.</small>

                      <b-field
                              style="display: block; margin-top: 4px;"
                              :type="{'is-danger': errors.has('shipping_method_form.shipping method' + index)}"
                              :message="errors.first('shipping_method_form.shipping method' + index)">
                        <p v-for="quoteData in cpOrderShipping.quotes" v-bind:key="quoteData.quote" class="has-text-left">
                          <b-radio
                                  v-model="reorderData.quotes[index]"
                                  :input="selectShippingMethod()"
                                  v-validate="'required'"
                                  data-vv-as="shipping method"
                                  data-vv-scope="shipping_method_form"
                                  :name="'shipping method' + index"
                                  :native-value="quoteData.quote">

                            <div class="columns">
                              <div class="column is-8" style="padding-top: 0; margin-bottom: 13px;">
                                <span class="title is-6">{{quoteData.meta.service}}</span><br>
                                <span class="title is-7">{{quoteData.meta.shipping_option}}</span>
                              </div>
                              <div class="column is-4 has-text-right" style="padding-top: 0">
                                0.00 EUR
                              </div>
                            </div>
                          </b-radio>
                        </p>
                      </b-field>
                    </section>
                  </td>
                </tr>
                <tr>
                  <td style="font-weight: bold;">Order mode</td>
                  <td class="has-text-right">
                    <template>
                      <section class="has-text-left">
                        <b-field
                                style="display: block; margin-top: 4px;"
                                :type="{'is-danger': errors.has('shipping_method_form.order mode')}"
                                :message="errors.first('shipping_method_form.order mode')">
                          <b-radio v-model="reorderData.mode"
                                   v-validate="'required'"
                                   data-vv-scope="shipping_method_form"
                                   name="order mode"
                                   native-value="live">
                            Live
                          </b-radio>
                          <br>
                          <b-radio v-model="reorderData.mode"
                                   v-validate="'required'"
                                   data-vv-scope="shipping_method_form"
                                   name="order mode"
                                   native-value="sandbox">
                            Sandbox
                          </b-radio>
                          <br>
                          <b-radio v-model="reorderData.mode"
                                   v-if="supportFeature('production_test_mode')"
                                   v-validate="'required'"
                                   data-vv-scope="shipping_method_form"
                                   name="order mode"
                                   native-value="production_test">
                            Production test
                          </b-radio>
                        </b-field>
                      </section>
                    </template>
                  </td>
                </tr>
                <tr v-if="!quoteError && reorderData.quotes">
                  <td style="border: none">
                    <span style="font-weight: bold">Total price</span>

                  </td>
                  <td class="has-text-right"
                      style="font-weight: bold; color: #055DC2; border: none">
                    Free
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>

import UserMixin from '@/mixins/UserMixin'

export default {
  name: 'StepFour',

  mixins: [UserMixin],

  data () {
    return {
      reorderData: {},
      cpOrderQuoteResponse: {},
      quoteError: null
    }
  },

  created () {
    this.reorderData = this.$store.getters['cpReorder/allData']
  },

  methods: {
    getTotalPrice: function () {
      return 0
    },

    selectShippingMethod: function () {
      this.reorderData.total_price = this.getTotalPrice()
    },

    getProductOptions: function () {
      let options = []

      for (let optionType in this.reorderData.cp_product_options) {
        if (optionType === 'count_pages') {
          options.push('Count pages: ' + this.reorderData.cp_product_options[optionType])
        }

        for (let option of this.reorderData.cpProductInfo.options) {
          if (option.type === optionType && option.option_reference === this.reorderData.cp_product_options[optionType]) {
            options.push(option.type_name + ': ' + option.note)
          }
        }
      }

      return options
    }
  }
}
</script>
